import React from 'react';
import './CreatorMark.css';

function CreatorMark() {
  return (
    <div className="creator-mark" aria-label="Creado por NYXN">
      <span>by</span>
      <img src="/assets/NYXN_LOGO-32.png" alt="NYXN" />
    </div>
  );
}

export default CreatorMark;
